export default "__VITE_ASSET__DoVV0n3M__"